import $ from 'jquery';
import debounce from 'lodash.debounce';

const init = () => {
  const navBarHeight = $('.navbar.fixed-top').height();
  $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click((e) => {
    const parser = document.createElement('a');
    if (e.target.href) {
      parser.href = e.target.href;
    } else {
      parser.href = $(e.target).parents('a').prop('href');
    }
    if (window.location.pathname.replace(/^\//, '') === parser.pathname.replace(/^\//, '') && window.location.hostname === parser.hostname) {
      let target = $(parser.hash);
      target = target.length ? target : $(`[name='${parser.hash.slice(1)}]`);
      if (target.length) {
        $('html, body').animate({
          scrollTop: (target.offset().top - navBarHeight),
        }, 1000, 'easeOutQuart');
        return false;
      }
    }
    return false;
  });

  // Closes responsive menu when a scroll trigger link is clicked
  $('.js-scroll-trigger').click(() => {
    $('.navbar-collapse').collapse('hide');
  });

  // Activate scrollspy to add active class to navbar items on scroll
  $('body').scrollspy({
    target: '#mainNav',
    offset: navBarHeight + 5,
  });

  // Collapse Navbar
  const navbarCollapse = () => {
    const hasClass = $('#mainNav').hasClass('navbar-shrink');
    const contentScrolled = $('#mainNav').offset().top > navBarHeight * 2;
    if (contentScrolled && !hasClass) {
      $('#mainNav').addClass('navbar-shrink');
    } else if (!contentScrolled && hasClass) {
      $('#mainNav').removeClass('navbar-shrink');
    }
  };
  // Collapse now if page is not at top
  navbarCollapse();
  // Collapse the navbar when page is scrolled
  $(window).scroll(debounce(navbarCollapse));
};

export default init;



// WEBPACK FOOTER //
// ./src/grayscale.js